// test869
(869 && 0);
